/* @ngInject */
function bannerService ($document, $timeout) {
  return {
    showBanner
  }

  // ----------------------------------------------------

  function showBanner (props, shouldClose) {
    var banner = _createBannerNode(props)

    if (shouldClose) {
      $timeout(() => {
        banner[0].show = false
      }, 6000, true)
    }

    banner[0].addEventListener('udsclose', (ev) => {
      $timeout(() => {
        ev.target.remove()
      }, 250, false)
    })

    $document.find('body').append(banner)
  }

  function _createBannerNode ({
    type,
    bannerLabel,
    bannerIcon,
    primaryBtnLabel,
    primaryBtnClick,
    tertiaryBtnLabel,
    tertiaryBtnClick
  }) {
    var bannerElement = angular.element(`<uds-banner type="${type}" message="${bannerLabel}" icon="${bannerIcon}" show="true"></uds-banner>`)

    if (primaryBtnLabel || tertiaryBtnLabel) {
      var primaryBtnElement = angular.element(`<uds-button type="primary" text="${primaryBtnLabel}"></uds-button>`)
      primaryBtnElement[0].addEventListener('udsclick', primaryBtnClick)

      var tertiaryBtnElement = angular.element(`<uds-button type="tertiary" text="${tertiaryBtnLabel}"></uds-button>`)
      tertiaryBtnElement[0].addEventListener('udsclick', tertiaryBtnClick)

      bannerElement.append(tertiaryBtnElement[0], primaryBtnElement[0])
    }

    return bannerElement
  }
}

export { bannerService }
